export default {
    xAxis: 'x-axis',
    yAxis: 'y-axis',
    size: 'size',
    panel: 'Panel filter'
}
